import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { UpdatePatientInforComponent } from './update-patient-information.component';

const updatePatientInforRoutes: Routes = [
  { path: '', component: UpdatePatientInforComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(updatePatientInforRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class UpdatePatientInforRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/update-patient-information/update-patient-information.component.routing.ts